import { withHandlers, compose } from 'recompose'
import Theme from 'components/common/Theme/Theme'
import { getEventHandlers } from './helpers'
import VehicleSelectorButtonGroup from './VehicleSelectorButtonGroup'

const withTileActivation = withHandlers({
  handleTileActivation:
    ({
      handleTrailerChange,
      makeActiveVehicle,
      setAppointmentActiveVehicle,
      setVehicleSelectorIsLoading,
      input: { onChange, value } = {},
      isTrailer
    }) => (userVehicleId, masterVehicle) => {
      if (value !== userVehicleId || isTrailer) {
        setVehicleSelectorIsLoading(true)
        handleTrailerChange(false)
        makeActiveVehicle({ userVehicleId, masterVehicle, setVehicleSelectorIsLoading })
        setAppointmentActiveVehicle({ userVehicleId })
        onChange(userVehicleId)
      }
    },
  handleTrailerActivation:
    ({ handleTrailerChange, input: { onChange } = {}}) => () => {
      handleTrailerChange(true)
      onChange(null)
    }
})

const withVehicleTilesEventHandlers = withHandlers({
  eventHandlers: ({ handleTileActivation }) =>
    (userVehicleId, masterVehicle = null) => getEventHandlers({
      userVehicleId,
      masterVehicle,
      handleClick: handleTileActivation,
      keyOptions: {
        [Theme.keyCode.ENTER]: handleTileActivation,
        [Theme.keyCode.SPACE]: handleTileActivation
      }
    })
})

export default compose(
  withTileActivation,
  withVehicleTilesEventHandlers
)(VehicleSelectorButtonGroup)
